module.exports = __webpack_public_path__ + "static/media/ad.e2dcf711.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_vas/ad.svg
// module id = 663
// module chunks = 0